/** 后端可能把 CROP- 流水号放在 subAccount，把展示用次号放在 id */
export function looksLikeCropTaskSerial(value) {
  const text = String(value || '').trim();
  return /^CROP-/i.test(text);
}

export function buildTaskIdCandidates(task) {
  // 路由与 cropImageAPI.save 使用 task.id，优先尝试避免误读空占位记录
  const raw = [task?.id, task?.taskId, task?.subAccount]
    .filter(Boolean)
    .map((v) => String(v).trim())
    .filter(Boolean);
  const serialLike = [];
  const rest = [];
  raw.forEach((id) => {
    if (looksLikeCropTaskSerial(id)) {
      if (!serialLike.includes(id)) serialLike.push(id);
    } else if (!rest.includes(id)) {
      rest.push(id);
    }
  });
  const ordered = [...serialLike, ...rest];
  return Array.from(
    new Set(
      ordered.flatMap((id) => [
        id,
        id.replace(/\s+/g, ''),
        id.replace(/\s+/g, '-'),
        id.replace(/-/g, ''),
        id.replace(/_/g, ''),
      ]),
    ),
  );
}
